import {
  canEditMemberPermissions,
  canViewMemberDetailsPermissions,
} from '../../../../../config/accessPolicies/accessPolicies';
import EditMemberModal from '../../../../../styledComponents/Modals/EditMemberModal/EditMemberModal';
import AAMembersList from '../../../../../styledComponents/ProductMembersList/AAMembersList/AAMembersList';
import { pageFilters } from './aaMembers.const';
import { useAAMembers } from './aaMembers.hooks';

const AAMembers = () => {
  const {
    pageListMembers,
    membersLoading,
    onRowClickHandler,
    rowEditHandler,
    onMemberEditedHandler,
    aaMembershipPricing,
  } = useAAMembers();

  return (
    <>
      <EditMemberModal onMemberEdited={onMemberEditedHandler} />
      <AAMembersList
        tableProps={{
          data: pageListMembers,
          isLoading: membersLoading,
          onRowClick: onRowClickHandler,
          onRowEdit: rowEditHandler,
          canViewDetailsPermissions: canViewMemberDetailsPermissions,
          canEditPermissions: canEditMemberPermissions,
        }}
        toolsProps={{
          availableFilters: pageFilters,
          standardPricing: aaMembershipPricing,
        }}
      />
    </>
  );
};

export default AAMembers;
